
import { UserProfile } from '@/types/auth';

/**
 * Safely formats a user's full name from UserProfile
 */
export const formatUserName = (user: UserProfile | null): string => {
  if (!user) return 'Unknown User';
  
  const firstName = user.first_name || '';
  const lastName = user.last_name || '';
  
  if (firstName && lastName) {
    return `${firstName} ${lastName}`.trim();
  }
  
  return user.name || firstName || lastName || 'Unknown User';
};

/**
 * Safely gets user email from UserProfile
 */
export const getUserEmail = (user: UserProfile | null): string => {
  if (!user || !user.email) return '';
  return user.email;
};

/**
 * Safely gets user avatar URL from UserProfile
 */
export const getUserAvatarUrl = (user: UserProfile | null): string => {
  if (!user || !user.avatar_url) return '';
  return user.avatar_url;
};

/**
 * Safely checks if user has a specific role
 */
export const hasUserRole = (user: UserProfile | null, role: string): boolean => {
  // Note: Role checking should be done server-side using has_role() function
  // This client-side check is deprecated and kept only for UI display purposes
  if (!user) return false;
  // Check if user has beta_access for beta_user role
  if (role === 'beta_user') return user.beta_access || false;
  return false;
};

/**
 * Safely gets user ID from UserProfile
 */
export const getUserId = (user: UserProfile | null): string => {
  if (!user || !user.id) return '';
  return user.id;
};

/**
 * Creates a safe user info object for PDF generation and other uses
 */
export const createUserInfo = (user: UserProfile | null) => {
  return {
    name: formatUserName(user),
    email: getUserEmail(user),
    id: getUserId(user),
    avatar_url: getUserAvatarUrl(user)
  };
};
